import { combineReducers } from "redux";
import { sessionReducer } from "redux-react-session";
import loginReducer from "services/redux/auth/login/reducer";
import loginOtp from "services/redux/auth/loginOtp/reducer";
import categoryDetlReducer from "services/redux/sales/corporate/categoryDetails/reducer";
import LeadDetailsReducer from "services/redux/sales/corporate/leadDetails/reducer";
import preSalesListReducer from "services/redux/sales/preSaleListing/reducer";
import locationReducer from "services/redux/sales/corporate/locations/reducer";
import pocTypesReducer from "services/redux/sales/corporate/pocDetails/reducer";
import preB2bReducer from "services/redux/sales/preSales/b2bAlliance/reducer";
import pocListReducer from "services/redux/sales/pocListing/reducer";
import followUpListReducer from "services/redux/sales/followUpListing/reducer";
import coporatePostLeadReducer from "services/redux/sales/postSales/corporate/reducer";
import contractCorporateReducer from "services/redux/sales/postSales/contractCorporate/reducer";
import contractAptReducer from "services/redux/sales/postSales/contractApt/reducer";
import InspectionReducer from "./maintenance/inspectionForm/reducer";
import postB2bReducer from "services/redux/sales/postSales/b2bAlliance/reducer";
import postSalesListReducer from "services/redux/sales/postSaleListing/reducer";
import salesApprovalReducer from "./approvals/salesApprovals/reducer";
import mrfDetailsReducer from "./installation/materialRequisition/reducer";
import siteLogReducer from "./installation/siteLog/reducer";
import appartmentPostLeadReducer from "services/redux/sales/postSales/apartment/reducer";
import followUpFormReducer from "services/redux/sales/followUpForm/reducer";
import assigneeReducer from "services/redux/sales/changeAssignee/reducer";
import supplyPostLeadReducer from "services/redux/sales/postSales/supply/reducer";
import fileUploadReducer from "services/redux/fileUpload/reducer";
import toastReducer from "services/redux/sales/appNotifications/reducer";
import currentLocationReducer from "services/redux/sales/currentLocation/reducer";
import siteListingReducer from "services/redux/installation/siteListing/reducer";
import jmsReducer from "services/redux/installation/jms/reducer";
import meetingReducer from "services/redux/installation/meetings/reducer";
import targetDataSequenceReducer from "services/redux/installation/TargetDate/reducer";
import siteStageReducer from "services/redux/installation/siteStages/reducer";
import siteInspectionReducer from "services/redux/installation/siteInspection/reducer";
import siteAssigneeReducer from "services/redux/installation/siteAssign/reducer";
import inventoryReducer from "services/redux/installation/inventoryCheckList/reducer";
import siteInfoReducer from "services/redux/installation/siteInformationCheckList/reducer";
import civilReducer from "services/redux/installation/civilCheckList/reducer";
import vendorReducer from "services/redux/installation/vendorAllocation/reducer";
import hardwareInstallReducer from "services/redux/installation/hardwareInstall/reducer";
import handOverReducer from "services/redux/installation/handOver/reducer";
import locationApprovalReducer from "services/redux/approvals/locationApprovals/reducer";
import pocReducer from "services/redux/sales/poc/reducer";
import postSalesReducer from "services/redux/sales/postSales/reducer";
import getDropDownReducer from "services/redux/sales/preSalesSupply/reducer";
import coporateLeadReducer from "services/redux/sales/corporate/reducer";
import gateReducer from "services/redux/sales/gates/reducer";
import siteEngineerListReducer from "./installation/siteEngineerList/reducer";
import siteEngineerDetailsReducer from "./installation/siteEngineerDetails/reducer";
import materialDeliveryReducer from "./installation/materialDelivery/reducer";
import tagDeliveryReducer from "./installation/tagDelivery/reducer";
import attendanceReducer from "./sales/attendance/reducer";
import mrfApprovalReducer from "services/redux/approvals/mrfApprovals/reducer";
import ticketsListingReducer from "./tickets/ticketsListing/reducer";
import ticketDetailsReducer from "./tickets/ticketDetails/reducer";
import createTicketReducer from "./tickets/createTicket/reducer";
import liveSiteDataReducer from "./maintenance/goLiveSite/reducer";
import pmListReducer from "./maintenance/pmList/reducer";
import pmSitiesReducer from "./maintenance/pmSities/reducer";
import pmDashboardReducer from "./maintenance/pmDashboard/reducer";
import fileComplainReducer from "./fileComplain/reducer";
import sitesLocMapReducer from "./sitesLocationMap/reducer";
import pmTicketReducer from "./maintenance/pmTicket/reducer";
import rmTicketReducer from "./maintenance/rmTicket/reducer";
import employeeTicketReducer from "./maintenance/employeeTickets/reducer";
import baSiteListingReducer from "services/redux/brandActivtion/sitesListing/reducer";
import baPocListReducer from "services/redux/brandActivtion/pocListing/reducer";
import baPocReducer from "services/redux/brandActivtion/poc/reducer";
import baMeetingReducer from "services/redux/brandActivtion/meetings/reducer";
import productsReducer from "services/redux/brandActivtion/products/reducer";
import BaDashboardReducer from "services/redux/brandActivtion/baDashboard/reducer";
import ConductCampReducer from "services/redux/brandActivtion/conductCamp/reducer";
import CorpClientReducer from "services/redux/brandActivtion/corporateClient/reducer";
import managePocReducer from "services/redux/brandActivtion/manageAddEditPoc/reducer";
import InvoiceReducer from "services/redux/brandActivtion/Invoice/reducer";
import approvedSalesListReducer from "./sales/approvedSalesListing/reducer";
import vendorPortalReducer from "./sales/vendorPortal/reducer";
import contractListingReducer from "./sales/contractListing/reducer";
import importReducer from "services/redux/sales/importLead/reducer";
import clientReducer from "services/redux/sales/corporate/client/reducer";
import FreshdeskReducer from "./maintenance/freshdesk/reducer";
import CreateInfraZoneReducer from "./Valet/InfraZone/reducer";
import CreateSupervisor from "./Valet/Supervisor/reducer";
import CreateValet from "./Valet/AddValet/reducer";
import CreateProject from "./Valet/Project/reducer";
import creditPolicyReducer from "./creditPolicy/reducer";
import businessItemReducer from "./businessItems/reducer";
import CreateIncentiveSlab from "./Valet/IncentiveSlap/reducer";
import NormalOnboarading from "./brandActivtion/NormalOnboarding/reducer";
import leadDataReducer from "./DistanceCalculator/reducer";
import projectOnboardingReducer from "./sales/projectOnboarding/reducer";
import bulkAssignmentReducer from "./BulkAssignment/reducer";
import NetEnggReducer from "./networkEngineer/reducer";
import SalesIncentiveReducer from "./salesIncentive/reducer";
import MaterialRequistionForm from "./MaterialRequistionForm/reducer";
import Wallet from "./Wallet/reducer";
import UnclaimedTranxReducer from "./maintenance/unclaimedTranx/reducer";
import HotoReducer from "./maintenance/hoto/reducer";
import projectConfigurationReducer from "./installation/projectCongifuration/reducer";
import contractAssetsMapping from "./ContractAssetsMapping/reducer";
import HelperDetails from "./HelperDetails/reducer";
import firAutofillData from "./installation/firForms/reducer";
import Training from "./Training/reducer";
import UserHelpdesk from "./userHelpdesk/reducer";
import toolkitInspection from "./ToolkitInspection/reducer";
import InvoiceModule from "./sales/InvoiceValidation/reducer";
import TutorialQuestions from "./tutorialQuestions/reducer";
import softwareRmTicketReducer from "./maintenance/softwareRmTicket/reducer";
import hardwareRmTicketReducer from "./maintenance/hardwareRmTicket/reducer";
import ValetIncentive from "./valetIncentive/reducer";
import campaignReducer from "./brandActivtion/adsCampaign/reducer";
import rcTransferReducer from "./RcTransfer/reducer";
import CarLoan from "./CarLoan/reducer";
import SendNotification from "./Valet/NotificationCentre/reducer";
import contractNewReducer from "./sales/postSales/contractNew/reducer";
import contractRenewalReducer from "./contractRenewal/reducer";
import offroleEmployeesReducer from "./OffRoleEmployees/reducer";
import lobReducer from "./Lob/reducer";
import fastagPricingReducer from "./fasTag/reducer";
import channelPartnerReducer from "./sales/channelPartner/reducer";
import siteDashboardReducer from "./sales/siteDashboard/reducer";
import dynamicContentsReducer from "./dynamicContents/reducer";
import siteLeadReferralReducer from "./siteLeadReferral/reducer";
import darwinReducer from "./darwin/reducer";
import clientClientReferralReducer from "./clientClientReferral/reducer";

const rootReducer = combineReducers({
  session: sessionReducer,
  loginOtp,
  loginReducer,
  InspectionReducer,
  LeadDetailsReducer,
  pocTypesReducer,
  categoryDetlReducer,
  locationReducer,
  pocReducer,
  lobReducer,
  gateReducer,
  preB2bReducer,
  preSalesListReducer,
  pocListReducer,
  followUpListReducer,
  getDropDownReducer,
  coporateLeadReducer,
  postSalesReducer,
  contractNewReducer,
  contractAptReducer,
  coporatePostLeadReducer,
  contractCorporateReducer,
  postB2bReducer,
  postSalesListReducer,
  salesApprovalReducer,
  appartmentPostLeadReducer,
  followUpFormReducer,
  assigneeReducer,
  supplyPostLeadReducer,
  fileUploadReducer,
  toastReducer,
  currentLocationReducer,
  siteListingReducer,
  jmsReducer,
  meetingReducer,
  targetDataSequenceReducer,
  siteStageReducer,
  siteInspectionReducer,
  siteAssigneeReducer,
  inventoryReducer,
  ticketsListingReducer,
  ticketDetailsReducer,
  siteInfoReducer,
  vendorReducer,
  civilReducer,
  hardwareInstallReducer,
  createTicketReducer,
  handOverReducer,
  locationApprovalReducer,
  mrfDetailsReducer,
  siteLogReducer,
  siteEngineerListReducer,
  siteEngineerDetailsReducer,
  materialDeliveryReducer,
  tagDeliveryReducer,
  attendanceReducer,
  mrfApprovalReducer,
  liveSiteDataReducer,
  pmListReducer,
  pmSitiesReducer,
  pmDashboardReducer,
  fileComplainReducer,
  sitesLocMapReducer,
  pmTicketReducer,
  rmTicketReducer,
  employeeTicketReducer,
  baSiteListingReducer,
  baPocListReducer,
  baPocReducer,
  baMeetingReducer,
  productsReducer,
  BaDashboardReducer,
  ConductCampReducer,
  CorpClientReducer,
  managePocReducer,
  InvoiceReducer,
  approvedSalesListReducer,
  vendorPortalReducer,
  contractListingReducer,
  importReducer,
  clientReducer,
  FreshdeskReducer,
  CreateInfraZoneReducer,
  CreateSupervisor,
  CreateValet,
  CreateProject,
  creditPolicyReducer,
  businessItemReducer,
  CreateIncentiveSlab,
  NormalOnboarading,
  leadDataReducer,
  projectOnboardingReducer,
  bulkAssignmentReducer,
  NetEnggReducer,
  SalesIncentiveReducer,
  MaterialRequistionForm,
  Wallet,
  UnclaimedTranxReducer,
  HotoReducer,
  projectConfigurationReducer,
  contractAssetsMapping,
  HelperDetails,
  firAutofillData,
  Training,
  UserHelpdesk,
  toolkitInspection,
  InvoiceModule,
  TutorialQuestions,
  softwareRmTicketReducer,
  hardwareRmTicketReducer,
  ValetIncentive,
  campaignReducer,
  rcTransferReducer,
  CarLoan,
  SendNotification,
  contractRenewalReducer,
  offroleEmployeesReducer,
  fastagPricingReducer,
  channelPartnerReducer,
  siteDashboardReducer,
  dynamicContentsReducer,
  siteLeadReferralReducer,
  darwinReducer,
  clientClientReferralReducer
});

export default rootReducer;
